unit LanguageTerm;
{

/* Initial. */

}
interface

type
  TLanguageTerm = class
  private
    p_String_Code: String;
    p_String_EnglishTerm: String;
    p_String_LanguageTerm: String;
    p_String_MemberOf: String;
  public
    constructor Create(const String_Code: String; const String_EnglishTerm: String; const String_LanguageTerm: String; const String_MemberOf: String);
    property Code: String read p_String_Code;
    property EnglishTerm: String read p_String_ENglishTerm;
    property LanguageTerm: String read p_String_LanguageTerm;
    property MemberOf: String read p_String_MemberOf;
  end;

implementation

constructor TLanguageTerm.Create(const String_Code: String; const String_EnglishTerm: String; const String_LanguageTerm: String; const String_MemberOf: String);
begin
    p_String_Code := String_Code;
    p_String_EnglishTerm := String_EnglishTerm;
    p_String_LanguageTerm := String_LanguageTerm;
    p_String_MemberOf := String_MemberOf
end;

end.
